import script from "./Otometro.vue?vue&type=script&setup=true&lang=ts"
export * from "./Otometro.vue?vue&type=script&setup=true&lang=ts"

import "./Otometro.vue?vue&type=style&index=0&id=7da3cb9f&lang=scss"

const __exports__ = script;

export default __exports__